import { APIResource } from '@/core/resources/APIResource'
import type { Creatable, Updatable } from '@/core/resources/APIResource'

export class Version extends APIResource implements Creatable<Version>, Updatable<Version> {
  apiRoute: string = 'versions'

  name: string = ''
  description: string = ''
  createDate: Date = new Date()
  doi: string = ''

  getIdentifier(): any {
    return this.name
  }

  fromJson(json: VersionResponse): this {
    this.name = json.name
    this.description = json.description
    this.createDate = new Date(json.begin_date)
    this.doi = json.doi
    return this
  }

  toJsonRequest(): VersionJsonRequest {
    return {
      name: this.name,
      description: this.description,
      doi: this.doi
    }
  }
}

export interface VersionResponse {
  name: string
  description: string
  begin_date: string
  doi: string
}

export interface VersionJsonRequest {
  name: string
  description: string
  doi: string
}

export default Version
